import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "product-family" }
const _hoisted_2 = { class: "section-small section-large-md-up" }
const _hoisted_3 = {
  key: 1,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductFamilyFinishes = _resolveComponent("ProductFamilyFinishes")!
  const _component_ProductFamilyResults = _resolveComponent("ProductFamilyResults")!
  const _component_LoadIndicator = _resolveComponent("LoadIndicator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($options.hasFinishFilter)
          ? (_openBlock(), _createBlock(_component_ProductFamilyFinishes, {
              key: 0,
              finishes: $options.finishesArray,
              portfolios: $options.portfoliosArray,
              styles: $options.stylesArray,
              activeFinish: $data.selectedFinish,
              onFilterChange: $options.filterChange
            }, null, 8 /* PROPS */, ["finishes", "portfolios", "styles", "activeFinish", "onFilterChange"]))
          : _createCommentVNode("v-if", true)
      ]),
      ($data.initialized && $options.resultsArray.length)
        ? (_openBlock(), _createBlock(_component_ProductFamilyResults, {
            key: 0,
            results: $options.resultsArray,
            translations: $data.translations
          }, null, 8 /* PROPS */, ["results", "translations"]))
        : _createCommentVNode("v-if", true),
      ($data.initialized && !$options.resultsArray.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No Results Available"))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_LoadIndicator, { loadingResults: $data.isLoading }, null, 8 /* PROPS */, ["loadingResults"])
  ], 64 /* STABLE_FRAGMENT */))
}